export default __webpack_public_path__ + "static/media/diamond-carat-3@2x.dcc5fb9d.jpg";